<label class="flex items-center gap-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300 cursor-pointer">
    <input [id]="id()" type="checkbox" class="cursor-pointer shrink-0" [checked]="checked()" [value]="value()?.id" [disabled]="disabled()" (change)="onChange.emit($event)">
    @if (icon(); as optionIcon) {
        <img [src]="optionIcon.src" alt="" class="h-5 w-5 shrink-0" [ngClass]="optionIcon.filterClass" />
    }
    <span
        class="truncate"
        [id]="labelId()"
        [ngClass]="{'font-bold!': description()}"
        [tooltip]="tooltipContent()"
        [position]="TooltipPosition.DYNAMIC"
        [visibleTooltip]="tooltipContent() !== '' && (alwaysShowTooltip() || utilsService.visibleTooltip(labelId()))"
    >
        {{ text() || value()?.name }}
        @if (description()) {
            <span> - {{ description() }}</span>
        }
    </span>
</label>
